<div>
    <h1>Mac Address Request Completed</h1>
    <h2>The MAC-Address for the provided serial number(s) are as following.</h2>
    <table>
        <thead>
            <tr class='table-header'>
                <th>serial number</th>
                <th>MAC-Address</th>
            </tr>    
        </thead>
        <tbody *ngIf="tableData && tableData.length > 0">
            <tr *ngFor="let data of tableData">
                <td>
                   <span [class.error]="data.error">{{data?.serialno}}</span>
                </td>
                <td *ngIf="!data.error" class='mac-address'>
                    {{data?.macaddress}}
                </td>
                <td *ngIf="data.error"  class="align-left">
                    <span class='error'>{{prepareErrorMessage(data?.error)}}</span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
